// extracted by mini-css-extract-plugin
export default {"finishMessage":"training-finish-message_finishMessage__xWDTg"};